"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStrategyMatrixQueryState = void 0;
const strategy_matrix_query_params_models_1 = require("./strategy-matrix-query-params.models");
const isRecord = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);
const isString = (value) => typeof value === 'string';
const isStringArray = (value) => Array.isArray(value) && value.every(isString);
const parseCompactSelection = (value) => {
    if (!isRecord(value) || value.selectAll !== true || !isStringArray(value.excludedValues)) {
        return undefined;
    }
    return {
        selectAll: true,
        excludedValues: value.excludedValues,
    };
};
const parseCompactChildren = (value) => (parseCompactSelection(value));
const parseSelectedCategory = (value) => {
    if (!isRecord(value) || !isString(value.id))
        return null;
    const selectedCategory = { id: value.id };
    if ('children' in value) {
        const compactChildren = parseCompactChildren(value.children);
        if (compactChildren) {
            selectedCategory.children = compactChildren;
        }
        else if (isStringArray(value.children)) {
            selectedCategory.children = value.children;
        }
        else {
            return null;
        }
    }
    return selectedCategory;
};
const parseSelectedCategories = (value) => {
    if (!Array.isArray(value))
        return undefined;
    const selectedCategories = value.map(parseSelectedCategory);
    if (!selectedCategories.every((item) => item != null))
        return undefined;
    return selectedCategories;
};
const parseCompactExtendedFilter = (value) => {
    if (!isRecord(value))
        return undefined;
    const compactSelection = parseCompactSelection(value);
    if (!compactSelection)
        return undefined;
    if (!('categories' in value)) {
        return compactSelection;
    }
    const categories = parseSelectedCategories(value.categories);
    if (!categories)
        return undefined;
    return Object.assign(Object.assign({}, compactSelection), (categories.length ? { categories } : {}));
};
const parseExtendedFilter = (value) => { var _a; return ((_a = parseSelectedCategories(value)) !== null && _a !== void 0 ? _a : parseCompactExtendedFilter(value)); };
const parseStrategyMatrixQueryState = (value) => {
    if (!isRecord(value) || value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.Version] !== strategy_matrix_query_params_models_1.STRATEGY_MATRIX_VIEW_QUERY_STATE_VERSION) {
        return null;
    }
    const state = {
        [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.Version]: strategy_matrix_query_params_models_1.STRATEGY_MATRIX_VIEW_QUERY_STATE_VERSION,
    };
    const extendedFilter = parseExtendedFilter(value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ExtendedFilter]);
    if (isString(value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ProjectId])) {
        state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ProjectId] = value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ProjectId];
    }
    if (isString(value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.CatalogId])) {
        state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.CatalogId] = value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.CatalogId];
    }
    if (extendedFilter)
        state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ExtendedFilter] = extendedFilter;
    if (isStringArray(value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes])) {
        state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes] = value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes];
    }
    if (isStringArray(value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable])) {
        state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable] = value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable];
    }
    if (isString(value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.TerminalNodeId])) {
        state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.TerminalNodeId] = value[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.TerminalNodeId];
    }
    return state;
};
exports.parseStrategyMatrixQueryState = parseStrategyMatrixQueryState;
